import { render } from "./BaseIndex.vue?vue&type=template&id=59ced9fe&scoped=true"
import script from "./BaseIndex.vue?vue&type=script&lang=js"
export * from "./BaseIndex.vue?vue&type=script&lang=js"

import "./BaseIndex.vue?vue&type=style&index=0&id=59ced9fe&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ced9fe"]])

export default __exports__